import { createFileRoute } from "@tanstack/react-router";

import { DatasetBrowser } from "@/features/assets/DatasetBrowser";

export const Route = createFileRoute("/_authenticated/data/search-terms")({
  component: () => <DatasetBrowser datasetId="search-terms-noop" />,
});
